import React from 'react';
import { Shield } from 'lucide-react';

export const AccessBlockedScreen = ({ onLogout }) => (
    <div className="min-h-screen w-full flex items-center justify-center bg-slate-950 text-white">
        <div className="text-center p-8 bg-slate-900 border border-slate-800 rounded-3xl shadow-2xl max-w-sm animate-fade-in">
            <div className="flex justify-center mb-4">
                <Shield size={48} className="text-red-500" />
            </div>
            <h2 className="text-xl font-bold mb-2">Acesso Restrito</h2>
            <p className="text-sm text-slate-400 mb-6">Você não possui a permissão básica para acessar o Hub Corporativo. Fale com um administrador.</p>
            <button onClick={onLogout} className="text-blue-400 hover:text-blue-300 text-sm font-bold">Sair do Sistema</button>
        </div>
    </div>
);

export default AccessBlockedScreen;
